import { KeyCode } from '../../constants/keyCodes'
import { isBodyActive } from './keyDownListenerService'

let keyMapping: Record<number, (event: KeyboardEvent) => void> = {}
let isListening = false

export function eventHandler(event: KeyboardEvent) {
  if (!isBodyActive()) {
    return
  }

  const handler = keyMapping[event.keyCode]
  if (handler) {
    handler(event)
  }
}

export function startListening(key: KeyCode, handler: (event: KeyboardEvent) => void) {
  keyMapping[key] = handler

  if (isListening) {
    return
  }

  window.addEventListener('keydown', eventHandler)
  isListening = true
}

export function stopListening(key: KeyCode) {
  delete keyMapping[key]
}

export function clearListener() {
  isListening = false
  window.removeEventListener('keydown', eventHandler)
  keyMapping = {}
}
